import React from 'react';

const Press = () => {
  const pressArticles = [
    {
      id: 1,
      publication: 'Fortune',
      logo: 'FORTUNE',
      title: 'Blue Tokai partners with Ambrosia Gulf for Middle East debut to brew first GCC outlet',
      image: '/images/press_blue_tokai.png',
      link: 'https://hospitality.economictimes.indiatimes.com/news/restaurants/blue-tokai-coffee-roasters-enters-uae-market-with-ambrosia-gulf-partnership/122368691'
    },
    {
      id: 2,
      publication: 'Inc42',
      logo: 'Inc42',
      title: 'Blue Tokai partners with Ambrosia Gulf for Middle East debut to brew first GCC outlet',
      image: '/images/press_blue_tokai_handshake.png',
      link: 'https://hospitality.economictimes.indiatimes.com/news/restaurants/blue-tokai-coffee-roasters-enters-uae-market-with-ambrosia-gulf-partnership/122368691'
    },
    {
      id: 3,
      publication: 'Fortune',
      logo: 'FORTUNE',
      title: 'Exclusive: Biryani By Kilo Raises $2 Mn From Pulsar Capital',
      image: '/images/press_bbk.png',
      link: 'https://inc42.com/buzz/biryani-by-kilo-raises-2-mn-from-pulsar-capital/'
    },
    {
      id: 4,
      publication: 'ET',
      logo: 'ET',
      title: 'Blue Tokai partners with Ambrosia Gulf for Middle East debut to brew first GCC outlet',
      image: '/images/press_blue_tokai.png',
      link: 'https://hospitality.economictimes.indiatimes.com/news/restaurants/blue-tokai-coffee-roasters-enters-uae-market-with-ambrosia-gulf-partnership/122368691'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative bg-gray-900 py-16">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-br from-transparent to-gray-800" />
          <div className="absolute top-0 right-0 w-1/2 h-full">
            <div className="grid grid-cols-4 gap-4 p-8 h-full opacity-50">
              {Array.from({ length: 20 }).map((_, i) => (
                <div key={i} className="bg-gray-700 rounded-lg h-16" />
              ))}
            </div>
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <p className="text-orange-400 font-semibold uppercase tracking-wide mb-4">
            IN THE NEWS
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            Press Coverage
          </h1>
        </div>
      </div>

      {/* Press Articles Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {pressArticles.map((article) => (
            <a
              key={article.id}
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white border border-gray-200 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer block"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                {/* Publication Logo Overlay */}
                <div className="absolute top-4 left-4 bg-black/70 px-3 py-1 rounded">
                  <span className="text-white font-bold text-sm">
                    {article.logo}
                  </span>
                </div>
                {/* Arrow Icon */}
                <div className="absolute top-4 right-4 bg-white/90 w-8 h-8 rounded-full flex items-center justify-center group-hover:bg-orange-500 group-hover:text-white transition-colors duration-300">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                  </svg>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 leading-tight group-hover:text-orange-600 transition-colors duration-200">
                  {article.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Press;